import { render, staticRenderFns } from "./LimitProductForm.vue?vue&type=template&id=48ef3828&scoped=true&"
import script from "./LimitProductForm.vue?vue&type=script&lang=js&"
export * from "./LimitProductForm.vue?vue&type=script&lang=js&"
import style0 from "./LimitProductForm.vue?vue&type=style&index=0&id=48ef3828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef3828",
  null
  
)

export default component.exports